<template>
<div class="chapter">
<div class="inner_page">
<p class="textcentera"><a id="ch00_fm05"></a><a id="page_v"><strong>For Sue Bender, who believes</strong></a></p><a id="page_v">
</a><p class="image"><a id="page_v"><img alt="image" src="images/f000v-01.jpg"/></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?cd259bbe